module.exports = "/static/js/94bf3cf066abce5fdda3b62ace789722.png";